import React, { useState, useEffect } from 'react';
import { Container, FormControl, Modal, Alert, Row, Col, Spinner } from 'react-bootstrap';
import '../../../../styles/RegDashboard.css';
import { HHIEButton } from '../../../utility/HHIEButton';

export function POCEmailChangeModal(props) {
    const [showModal, setShowModal] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [success, setSuccess] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [member, setMember] = useState(null);
    const [newEmail, setNewEmail] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setShowModal(props.showModal);
        setMember(props.member);
    }, [props]);

    const submitRequest = () => {
        const formData = new FormData();
        formData.append("sfid", member.id);
        formData.append("firstName", member.firstName);
        formData.append("middleName", member.middleName);
        formData.append("lastName", member.lastName);
        formData.append("userIsPoc", props.user.isPOCUser);
        formData.append("userId", props.user.userID);
        formData.append("userSfid", props.user.sfid);
        formData.append("currentEmail", member.email);
        formData.append("newEmail", newEmail);
        const requestOptions = {
            method: 'POST',
            body: formData
        }

        fetch('api/registration/submitPOCEmailChangeRequest', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        setLoading(false);
                        setAlertMessage(text.message);
                        setSuccess(text.message.includes("Success"));
                        setShowAlert(true);
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
            })
    }

    return (
        <Modal
            id="poc-email-change-modal"
            show={showModal}
            size="lg"
            centered
            onHide={() => { setShowModal(false); props.setShowModal(false) }}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    POC Email Change Request
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <div>New Email</div>
                    <FormControl
                        required
                        isInvalid={!newEmail || !(newEmail.includes("@") && newEmail.includes("."))}
                        type="text"
                        placeholder={props.member.email ?? "New Email Address"}
                        defaultValue={(newEmail) ?? undefined}
                        id="email"
                        name="email"
                        aria-label="email"
                        aria-describedby="email"
                        onChange={(e) => { setNewEmail(e.target.value) }}
                    />
                </Container>
            </Modal.Body>
            <br />
            <Modal.Body>
                {
                    showAlert ?
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <Alert variant={success ? "success" : "warning"}>{alertMessage}</Alert>
                            </Col>
                        </Row>
                        :
                        <Col className="d-flex justify-content-center">
                            <HHIEButton
                                disabled={loading || !newEmail || !(newEmail.includes("@") && newEmail.includes("."))}
                                id="poc-email-change-btn"
                                title={loading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : "POC Email Change Request"}
                                onClick={() => { setLoading(true); submitRequest() }}
                            />
                        </Col>
                }
            </Modal.Body>
        </Modal>
    );
}
